import { fetchApiData } from '../../../Utils/ApiCalls';
import { COMPANIES_ENDPOINT } from '../../../urls';

const normalizeCompany = company => {
  const id = company?.id ?? company?.company_id;
  if (id == null || id === '') return null;
  return {
    id: String(id),
    name: company.name || company.company_name || 'Untitled company'
  };
};

export const normalizeCompanies = data => {
  const raw = Array.isArray(data) ? data : data?.results || data?.companies || [];
  const seen = new Set();
  return raw.map(normalizeCompany).filter(company => {
    if (!company || seen.has(company.id)) return false;
    seen.add(company.id);
    return true;
  });
};

export const searchBidOpsCompanies = ({ q, signal } = {}) =>
  fetchApiData({
    endpoint: COMPANIES_ENDPOINT,
    apiRequest: 'GET',
    params: {
      q
    },
    signal
  });
